module.exports = __webpack_public_path__ + "static/artist-development-hero-da5c9cb4d54ac718cb4dfc1496191a75.webp";